import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/app/(public)/[sport]/teams/[team]/[year]/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/primitives/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/team/injuries-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/team/logo.tsx");
